// import React from "react";
// import { Link } from "react-router-dom";

// const MegaMenu = ({ subcategories, category }) => {
//   console.log("subcategories", subcategories);
//   return (
//     <div
//       className="absolute mt-7 top-full left-1/2 transform -translate-x-1/2 bg-white z-50 shadow-lg border-b border-gray-200 px-6 py-1 text-sm "
//       style={{ width: "1000px", marginLeft: "250px", height: "fit-content" }}
//     >
//       <div className="w-full px-8 py-2 flex justify-between">
//         {/* Column 3: Accessories */}
//         {subcategories.map((sub) => (
//           <div key={sub.name}>
//             <h3 className="text-gray-500 text-sm mb-2 font-semibold">
//               {sub.name}
//             </h3>
//             <ul
//               className="space-y-0.1 text-black text-sm "
//               style={{ marginTop: "6px" }}
//             >
//               {sub.children &&
//                 sub.children.length > 0 &&
//                 sub.children.map((child) => (
//                   <li key={child.id}>
//                     <Link
//                       to={`/${category}/${child.slug}`}
//                       className="block py-1 text-sm hover:text-red-600"
//                     >
//                       {child.name}
//                     </Link>
//                   </li>
//                 ))}
//             </ul>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default MegaMenu;

import React from "react";
import { Link } from "react-router-dom";

const MegaMenu = ({ subcategories, category }) => {
  return (
    <div
      className="absolute mt-7 top-full left-1/2 transform -translate-x-1/2 bg-white z-50 shadow-lg border-b border-gray-200 px-6 py-1 text-sm"
      style={{ width: "900px", marginLeft: "250px", height: "fit-content" }}
    >
      <div className="w-full px-8 py-4 grid grid-cols-3 gap-x-8 gap-y-6">
        {subcategories.map((sub) => (
          <div key={sub.name}>
            <h3 className="text-gray-500 text-sm mb-2 font-semibold">
              {sub.name}
            </h3>
            <ul className="space-y-1 text-black text-sm">
              {sub.children &&
                sub.children.length > 0 &&
                sub.children.map((child) => (
                  <li key={child.id}>
                    <Link
                      to={`/${category.toLowerCase()}/${child.slug}`}
                      className="block py-1 text-sm hover:text-red-600"
                    >
                      {child.name}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MegaMenu;
